import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#007A7A', // Teal (Bankers Surety brand)
      light: '#339999',
      dark: '#005858',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F18F01', // Orange (Bankers Surety accent)
      light: '#FFB040',
      dark: '#C77200',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f9f9f9', // Light grey for a softer background
      paper: '#ffffff',
    },
    text: {
      primary: '#333333', // Dark Grey/Black for better contrast
      secondary: '#666666',
    },
    error: {
      main: '#d32f2f',
      contrastText: '#ffffff',
    },
    success: {
      main: '#2e7d32',
      contrastText: '#ffffff',
    },
    appBar: {
      main: '#f9f9f9', // AppBar background
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h6: {
      color: '#333333', // Darker color for h6 (used in AppBar)
      fontWeight: 600, // Make the text a bit bolder
    },
    body1: {
      color: '#333333', // Ensure body text is also readable
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#F4F4F9', // AppBar background color
          boxShadow: 'none', // Remove the default shadow
          borderBottom: '3px solid #e0e0e0', // Add a subtle bottom border
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          maxWidth: '1400px', // Override the default 'lg' container size to 1400px
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
          textTransform: 'none', // Keep button text as-is (no uppercase)
        },
        containedPrimary: {
          backgroundColor: '#007A7A',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#005858',
          },
        },
        containedSecondary: {
          backgroundColor: '#F18F01',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#C77200',
          },
        },
        outlinedPrimary: {
          borderColor: '#007A7A',
          color: '#007A7A',
          '&:hover': {
            borderColor: '#005858',
            backgroundColor: 'rgba(0, 122, 122, 0.04)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#007A7A',
          color: '#ffffff',
        },
        colorSecondary: {
          backgroundColor: '#F18F01',
          color: '#ffffff',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#007A7A',
          '&:hover': {
            color: '#005858',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.8)', // Ensure good readability
            backgroundColor: '#f5f5f5', // Light background for contrast
            borderColor: 'rgba(0, 0, 0, 0.2)', // Subtle border
            fontWeight: 500, // Increase font weight for better readability
            fontSize: '1rem', // Adjust font size for readability
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1320, // Override 'lg' breakpoint value to 1400px
      xl: 1920,
    },
  },
});

export default theme;
